import { TsThumbnail } from '@app/core/thumbnails/components/TsThumbnail';
import {
  THUMB_PREVIEW_WIDTH,
  THUMB_PREVIEW_WIDTH_COMPACT,
  THUMBNAIL_HEIGHT_COMPACT,
  THUMBNAIL_HEIGHT_DEFAULT,
} from '@app/modules/logger/screens/status/constants';
import { Segment, Timestamp } from '@mi-front/core';
import { Box } from '@mui/material';
import { useMemo } from 'react';
import { getRangeForSegments } from '../../../../../stream/helpers/get-range-for-segments';
import { useStatusViewContext } from '../../../../context/StatusViewContext';
import { Station } from '@app/core/types/stations';

interface Props {
  readonly station: Station;
  readonly ts: Timestamp;
  readonly segments: readonly Segment[];
}

/**
 * Displays the thumbnail for a specific timestamp.
 * Used when the user hovers over the waveform to show a preview at that time.
 */
export function HoverStatusThumbnail(p: Props) {
  const { station, ts, segments } = p;
  const { compact } = useStatusViewContext();
  const width = compact ? THUMB_PREVIEW_WIDTH_COMPACT : THUMB_PREVIEW_WIDTH;
  const targetHeight = compact ? THUMBNAIL_HEIGHT_COMPACT : THUMBNAIL_HEIGHT_DEFAULT;

  const useThumbnailOptions = useMemo(() => {
    const { from, to } = getRangeForSegments([...segments]);
    return { range: { from, to } };
  }, [segments]);

  return (
    <Box
      sx={{
        width,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <TsThumbnail
        stationId={station.id}
        ts={ts}
        useThumbnailOptions={useThumbnailOptions}
        targetHeight={targetHeight}
      />
    </Box>
  );
}
